import {
  CloseRounded, FilterListRounded, SearchRounded,
} from '@mui/icons-material';
import {
  Box, Button, Container, Drawer, IconButton, Skeleton, TextField, Checkbox,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';
import AlertContext from '../../../../Context/AlertContext';
import { getUserItems } from '../../../../Redux/Models/box';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import dummy from '../../../../Configs/dummy';

export default function Component({
  error, message, items, isLoading, classes,
}) {
  const user = getUserData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openAlert } = useContext(AlertContext);
  const [param, setParam] = useSearchParams();
  const { t } = useTranslation();
  const [checkedItems, setCheckedItems] = useState([]);

  const handleToggleCheck = (e, item) => {
    if (e.target.checked) {
      setCheckedItems([...checkedItems, item]);
    } else {
      setCheckedItems(checkedItems.filter((i) => i.id !== item.id));
    }
  };

  const sorts = [
    {
      label: t('filter.newest'),
      value: 'desc',
    },
    {
      label: t('filter.oldest'),
      value: 'asc',
    },
  ];

  const sort = param.get('sort') || '';

  const [openFilter, setOpenFilter] = useState(false);

  const getData = () => {
    dispatch(getUserItems(user.id, { sort }));
  };

  const toggleOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handleApplyFilter = async () => {
    getData();
    setOpenFilter(false);
  };

  const handleResetFilter = async () => {
    await setParam({ });
    getData();
  };

  useEffect(() => {
    if (error) {
      openAlert({
        title: 'Something went wrong.',
        message,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    getData();
  }, []);

  const renderItems = () => {
    if (isLoading) {
      return new Array(5).fill(0).map((item, index) => (
        <Box display="flex" gap={1.5} mt={2} key={index}>
          <Skeleton
            variant="rect"
            width="80px"
            height="80px"
            className="rounded"
            alt="baco"
          />
          <Box flex={1}>
            <Skeleton />
            <Skeleton sx={{ mt: 1 }} />
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
              <Skeleton width="40px" />
              <Skeleton width="40px" />
            </Box>
          </Box>
        </Box>
      ));
    }
    if (!items.length) {
      return (
        <Box className="center mt-4" sx={{ px: 2, pb: 1 }}>
          <img src={Images.EmptyBox} alt="Empty box" />
          <div className="mt-3 height-14">
            <Box className="weight-700 s-16">{t('myStoragesPage.noAvail')}</Box>
            <Box my={1} className="s-14">
              {t('myStoragesPage.noAvailDesc1')}
              <br />
              {t('myStoragesPage.noAvailDesc2')}
            </Box>
            {user.subscription
            && <Button variant="contained" className="btn-contained" fullWidth onClick={() => navigate(ROUTES.requestStorage())}>{t('myStoragesPage.storeWine')}</Button>}
          </div>
        </Box>
      );
    } if (items.length) {
      return items
        .filter((item) => !item.is_process)
        .map((item) => (
          <Box display="flex" gap={1.5} key={item.id} mt={2} alignItems="center">
            <Checkbox
              sx={{ alignSelf: 'center', p: 0 }}
              checked={checkedItems.find((i) => i.id === item.id)}
              onChange={(e) => handleToggleCheck(e, item)}
              disabled={item.item?.is_sale || item.box?.is_sale}
            />
            <img
              onClick={() => navigate(item.id)}
              width="80"
              height="80"
              className="rounded cover"
              src={item.item?.photo || item.box?.photo || dummy.img}
              alt={item.name}
            />
            <Box flex={1} onClick={() => navigate(item.id)}>
              {item.type === 'Box'
                ? (
                  <>
                    <div className="weight-600">
                      {item.box?.name || `Box ${item.box?.digital_box_id}`}
                    </div>
                    <Box>
                      {item.box?.amount}
                      {' '}
                      {t('common.items')}
                    </Box>
                  </>
                ) : (
                  <>
                    <div className="weight-600">{item.item?.name}</div>
                    <Box display="flex" className="s-10" color="#586479" gap={0.5} flexWrap="wrap" alignItems="center">
                      <div>{item.category?.name || '-'}</div>
                      <div>
                        ・
                        {item.condition?.name || '-'}
                      </div>
                      <div>
                        ・
                        {item.item?.volume || 0}
                        {' '}
                        ml
                      </div>
                    </Box>
                  </>
                )}
              {!!item.item?.is_sale
            && (
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
              <Box className="s-10 mute weight-600">
                {t('productDetails.inCellar')}
                {' '}
                {moment(item.item?.marketed_on).format('DD MMM YYYY')}
              </Box>
              <Box display="flex" gap={0.5}>
                <img src={Images.Setting} alt="setting-icon" />
                <img src={Images.CheckRed} alt="check-icon" />
              </Box>
            </Box>
            )}
            </Box>
          </Box>
        ));
    }

    return null;
  };

  return (
    <Elements.PageBase>
      <Box bgcolor={Colors.primary}>
        <Container
          sx={{
            py: 2,
          }}
          className={classes.root}
        >
          <h4 className="white">{t('myStoragesPage.title')}</h4>
          <Elements.StorageQuota
            mt={1}
            bgcolor="#FDFDFD"
            px={1}
            py={1.5}
            borderRadius="10px"
          />
        </Container>
      </Box>

      <Container sx={{
        py: 2,
      }}
      >
        <TextField
          fullWidth
          size="small"
          InputProps={{
            endAdornment: <SearchRounded />,
          }}
          placeholder={t('common.search')}
          autoComplete="new-password"
          sx={{
            bgcolor: 'white',
            borderRadius: 2,
            overflow: 'hidden',
            outline: 'none',
            mb: 2,
          }}
        />
        <Box display="flex" justifyContent="space-between">
          <Box>
            {t('myStoragesPage.stored', { count: items.length })}
          </Box>
          <Button
            startIcon={<FilterListRounded />}
            sx={{
              color: 'black',
              px: 1,
              py: 0.25,
              textTransform: 'none',
              border: '1px solid #E5E5E5',
              borderRadius: 2,
            }}
            onClick={toggleOpenFilter}
          >
            {t('filter.title')}
          </Button>
        </Box>
        {renderItems()}
      </Container>
      <Box mt={3}>
        {!!checkedItems.length
        && (
        <Box position="fixed" bottom={50} bgcolor="#FDFDFD" left="0" right="0">
          <Container maxWidth="xs" sx={{ py: 1.5 }}>
            <Box display="flex" gap={2}>
              {/* <Button
                variant="outlined"
                className="btn-outlined"
                fullWidth
                onClick={() => navigate(`${ROUTES.requestOut()}`, { state: checkedItems })}
              >
                Request out
              </Button> */}
              <Button variant="contained" className="btn-contained" fullWidth onClick={() => navigate(ROUTES.sellMultiProduct(), { state: checkedItems })}>Sell on market</Button>
            </Box>
          </Container>
        </Box>
        )}
        <Elements.Footer />
      </Box>

      <Drawer
        open={openFilter}
        anchor="bottom"
        sx={{ borderRadius: 2 }}
        PaperProps={{ elevation: 0, style: { backgroundColor: '#FDFDFD', borderRadius: '10px 10px 0 0' } }}
        onClose={toggleOpenFilter}
      >
        <Container maxWidth="xs" sx={{ py: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <IconButton sx={{ p: 0 }} onClick={toggleOpenFilter}>
              <CloseRounded sx={{ fontSize: 18, color: '#404852' }} />
            </IconButton>
            <Box fontSize={16} fontWeight="700">{t('filter.title')}</Box>
            <Box className="primary-green link" fontSize={14} onClick={handleResetFilter}>{t('filter.reset')}</Box>
          </Box>

          <Box mt={2} mb={1} fontSize={14} fontWeight="600">{t('filter.sort')}</Box>
          <Box display="flex" gap={0.5}>
            {sorts.map((st) => (
              <Box
                fontSize={14}
                bgcolor={sort === st.value ? Colors.primary : 'transparent'}
                color={sort === st.value ? '#fff' : '#404852'}
                key={st.value}
                py="4px"
                px={1}
                borderRadius={2}
                fontWeight="600"
                border="1px solid #E5E5E5"
                className="link"
                onClick={() => setParam({ sort: st.value })}
              >
                {st.label}
              </Box>
            ))}
          </Box>

          <Button
            fullWidth
            className="btn-contained"
            variant="contained"
            sx={{ mt: 2 }}
            onClick={handleApplyFilter}
          >
            {t('filter.apply')}
          </Button>
        </Container>
      </Drawer>
    </Elements.PageBase>
  );
}
